/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ExamVm,
    ExamVmFromJSON,
    ExamVmFromJSONTyped,
    ExamVmToJSON,
} from './';

/**
 * 
 * @export
 * @interface ExamVmPaginatedSearchResponse
 */
export interface ExamVmPaginatedSearchResponse {
    /**
     * 
     * @type {Array<ExamVm>}
     * @memberof ExamVmPaginatedSearchResponse
     */
    items?: Array<ExamVm> | null;
    /**
     * 
     * @type {number}
     * @memberof ExamVmPaginatedSearchResponse
     */
    totalCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamVmPaginatedSearchResponse
     */
    from?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamVmPaginatedSearchResponse
     */
    to?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamVmPaginatedSearchResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof ExamVmPaginatedSearchResponse
     */
    size?: number;
}

export function ExamVmPaginatedSearchResponseFromJSON(json: any): ExamVmPaginatedSearchResponse {
    return ExamVmPaginatedSearchResponseFromJSONTyped(json, false);
}

export function ExamVmPaginatedSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExamVmPaginatedSearchResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : (json['items'] as Array<any>).map(ExamVmFromJSON)),
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'from': !exists(json, 'from') ? undefined : json['from'],
        'to': !exists(json, 'to') ? undefined : json['to'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'size': !exists(json, 'size') ? undefined : json['size'],
    };
}

export function ExamVmPaginatedSearchResponseToJSON(value?: ExamVmPaginatedSearchResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': value.items === undefined ? undefined : (value.items === null ? null : (value.items as Array<any>).map(ExamVmToJSON)),
        'totalCount': value.totalCount,
        'from': value.from,
        'to': value.to,
        'page': value.page,
        'size': value.size,
    };
}


